module.exports = __webpack_public_path__ + "img/gift_en-BE.f93dd169.svg";